module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-vi-VN.e8eaf239.jpg";